import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DateFormatPipe} from "../date/date.pipe";

@Pipe({
    name: 'dateAgo',
    standalone: true
})
export class DateAgoPipe implements PipeTransform {
  constructor(private translateService: TranslocoService, private df: DateFormatPipe) { }


  transform(value: any, ...args: unknown[]): unknown {
    if (!value) { return 'a long time ago'; }
    let time = (Date.now() - Date.parse(value)) / 1000;

    if (time < 10) {
      return this.translateService.translate('datetime.NOW');
    } else if (time < 60) {
      return this.translateService.translate('datetime.MOMENT_AGO');
    } else if (time > 86400) {
      return this.df.transform(value, 'comments');
    }

    const divider = [60, 60, 24];
    const string = ['SECOND', 'MINUTE', 'HOUR', 'DAY', 'MONTH', 'YEAR'];
    let i;
    for (i = 0; Math.floor(time / divider[i]) > 0; i++) {
      time /= divider[i];
    }
    const plural = Math.floor(time) > 1 ? 'S' : '';
    const key: string = this.translateService.translate('datetime.' + string[i] + plural) + ' ' + this.translateService.translate('datetime.AGO');
    return Math.floor(time) + ' ' + key;
  }
}
